/*
* 权限管理组件
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    Row,
    Col,
    message,
    Table,
    Input,
    Select,
    Button,
    Upload,
    Modal,
    Space,
} from 'antd';
import {
    PlusOutlined,
    ExportOutlined,
    ImportOutlined,
} from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    isGTscreenWidth,
    ShowIPModal,
    DateFormat,
    GetDropdownActionName,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import AuthorityEntity from './AuthorityEntity';

const Option = Select.Option;
const MODULENAME = CNF.navItems[4].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[4].ptn;

class Lists extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ulid: '',
            dataLists: this.props.dataLists
        }
    }

    update = (record) => { this.props.setIsModalOpen(true, record); }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.dataLists !== nextProps.dataLists) {
            this.setState({
                dataLists: nextProps.dataLists,
            })
        }
    }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    operation = (action, record) => {
        let uri = 'authoritys/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                this.update(record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.name, action, MODULENAME, this.props.isRefresh, uri);
                break
            default:
                break;
        }
    }


    render() {
        const columns = [
            { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
            { title: '前缀', dataIndex: 'prefix', key: 'prefix', },
            { title: '权限名', dataIndex: 'name', key: 'name', },
            { title: '描述', dataIndex: 'description', key: 'description', },
            { title: '状态', key: 'status', dataIndex: 'status', width: CNF.tableStatusColumnWidth, },
            { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
            { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
            {
                title: '', key: 'operation', width: CNF.tableOperationColumnWidth,
                render: (record) => GetDropdownActionName(this.props.btnLists, MODULENAME_PTN, record, this.operation)
            }
        ];
        return (
            <div>
                <Table
                    columns={columns}
                    size='middle'
                    dataSource={this.state.dataLists}
                    scroll={{ x: this.props.x }}
                    pagination={{
                        showSizeChanger: false,
                        // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                        showQuickJumper: false,
                        showTotal: () => `共${this.props.pageCount}条`,
                        pageSize: CNF.pageSize,
                        current: this.props.currentIndex,
                        total: this.props.pageCount,
                        onShowSizeChange: (current, pageSize) => this.props.changePageSize(pageSize, current),
                        onChange: (current) => this.props.changeIndex(current),
                    }}
                />
            </div>
        );
    }
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            isModalOpen: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            name: '',
            status: CNF.status[0].value,
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeName = (e) => { this.setState({ name: e.target.value.replace(/ /g, '') }); if (e.target.value.replace(/ /g, '') !== '') this.search(); }
    changeStatus = (value) => { this.setState({ status: value }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }
    setIsModalOpen = (value, record) => { this.setState({ isModalOpen: value, record: record }); }
    create = () => { this.setIsModalOpen(true, null); }

    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'name': this.state.name,
            'status': this.state.status === undefined ? '' : this.state.status,
            'page_size': isGTscreenWidth ? CNF.pageSize : CNF.pageSize - 2,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}authoritys${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done(function (data) {
            if (data.res === 0) {
                if (data.dat.length > 0) {
                    _this.setState({
                        dataLists: data.dat,
                        pageCount: data.cnt
                    });
                } else {
                    _this.setState({
                        dataLists: [],
                        pageCount: 0
                    });
                }
            } else {
                message.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            message.error(data.responseJSON.detail, CNF.messageDuration);
        });
    }

    /**
     * 导入前检查
     * @param {*} info 
     * @returns 
     */
    uploadCheck = (info) => {
        if (info.size > 5120000) {
            message.error('上传文件超过5M, 建议拆分文件!', CNF.messageDuration);
            return false
        }
        if (info.name.match(/.xls[x]{0,1}/) === null) {
            message.error('文件格式不对, 只支持xls或xlsx !', CNF.messageDuration);
            return false
        }
        return true
    }

    /**
     * 执行导入
     * @param {*} info 
     */
    upload = (info) => {
        const _this = this;
        if (info.file.status === 'uploading') {
            message.loading({ content: '文件正在导入...', key: 'import', duration: 0 });
        } else if (info.file.status === 'done') {
            message.success({ content: '文件导入完成！', key: 'import', duration: CNF.messageDuration });
            if (info.file.response.dat) {
                setTimeout(function () {
                    Modal.success({
                        title: '导入权限',
                        width: 600,
                        content: (
                            <div style={{ height: '300px', overflow: 'scroll' }}>
                                <Row style={{ lineHeight: 2 }} key={0}>
                                    <Col span={3}>行号</Col>
                                    <Col span={15}>权限名</Col>
                                    <Col span={6}>操作说明</Col>
                                </Row>
                                {
                                    info.file.response.dat.length &&
                                    info.file.response.dat.map((item) => {
                                        return (
                                            <Row style={{ lineHeight: 2 }} key={item['key']}>
                                                <Col span={3}>{item['key']}</Col>
                                                <Col span={15}>{item['name']}</Col>
                                                <Col span={6}>{item['msg']}</Col>
                                            </Row>
                                        )
                                    })
                                }
                            </div>
                        ),
                        onOk() { _this.isRefresh(); },
                    });
                }, 2000)
            } else {
                message.error(info.file.response.msg, CNF.messageDuration);
            }
        } else if (info.file.status === 'error') {
            message.loading({ content: '文件正在导入...', key: 'import', duration: 0.001 });
            message.error(`${info.file.name} 导入失败！`, CNF.messageDuration);
        }
    }

    /***
    * 导出 Excel
    */
    export = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '权限管理-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '权限明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '前缀',
                    '权限名',
                    '描述',
                    '状态',
                    '创建时间',
                    '创建者'],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出车辆信息明细
     */
    exportObtain() {
        const _this = this
        const params = {
            'name': this.state.name,
            'status': this.state.status === undefined ? '' : this.state.status,
            'page_size': 65535,
            'current_index': 1
        }
        $.ajax({
            url: `${CNF.api}authoritys${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        //  删除非必须字段
                        var d = [];
                        for (let i = 0; i < data.dat.length; i++) {
                            var item = data.dat[i]
                            delete item['key'];
                            delete item['create_username'];
                            delete item['update_time'];
                            d.push(item);
                        }
                        _this.export(d);
                    } else {
                        _this.export([]);
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <div>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 3 : 4}>
                        <Input
                            onChange={this.changeName}
                            onPressEnter={this.search}
                            placeholder='权限名'
                            value={this.state.name}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='状态'
                            value={this.state.status}
                            style={{ width: '100%' }}
                            onChange={this.changeStatus}
                        >
                            {
                                CNF.status && CNF.status.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_create') >= 0 ? (
                                <Button
                                    title={CNF.actionName.CREATE + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<PlusOutlined />}
                                    onClick={() => {
                                        this.create();
                                    }}>
                                    {CNF.actionName.CREATE}
                                </Button>
                            ) : ''
                        }
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_import') >= 0 ? (
                                <Upload
                                    action={CNF.api + 'authoritys/lists'}
                                    headers={AddRequestHeaders('')}
                                    onChange={this.upload}
                                    beforeUpload={this.uploadCheck}
                                    showUploadList={false}
                                    name='file'
                                    accept='xlsx,xls'
                                >
                                    <Button
                                        title={CNF.actionName.IMPORT + MODULENAME}
                                        color='primary'
                                        variant='solid'
                                        icon={<ImportOutlined />}
                                    >
                                        {CNF.actionName.IMPORT}
                                    </Button>
                                </Upload>
                            ) : ''
                        }
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_export') >= 0 ? (
                                <Button
                                    title={CNF.actionName.EXPORT + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<ExportOutlined />}
                                    onClick={() => {
                                        this.exportObtain();
                                    }}>
                                    {CNF.actionName.EXPORT}
                                </Button>
                            ) : ''
                        }
                        <AuthorityEntity
                            btnLists={this.props.btnLists}
                            isModalOpen={this.state.isModalOpen}
                            record={this.state.record}
                            setIsModalOpen={this.setIsModalOpen}
                            isRefresh={this.isRefresh}
                        />
                    </Space>
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            btnLists={this.props.btnLists}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            setIsModalOpen={this.setIsModalOpen}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default CPT